<!-- <footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © {{'COMMON.DEBEN' | translate}}
            </div>
        </div>
    </div>
</footer> -->


<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="text-start">
                <p class="mb-0 text-muted">&copy; {{year}} {{ 'COMMON.DEBEN' | translate }} {{
                    'COMMON.All_RIGHTS_RESERVED' | translate }}
            </div>
        </div>
    </div>
</footer>